var require_runtime = require('../../_virtual/_rolldown/runtime.cjs');
//#region src/types/plugins/ConsumeSharedPlugin.ts
var ConsumeSharedPlugin_exports = /* @__PURE__ */ require_runtime.__exportAll({});
//#endregion
Object.defineProperty(exports, 'ConsumeSharedPlugin_exports', {
    enumerable: true,
    get: function get() {
        return ConsumeSharedPlugin_exports;
    }
}); //# sourceMappingURL=ConsumeSharedPlugin.cjs.map
